import { MenuItem, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { formatCurrencyValueToNumber } from 'utils/helpers';

import InputCell from './input-cell';
import { Controller, UseFormReturn } from 'react-hook-form';
import { ProjectedPaymentsForm } from '../services';
import { useTranslation } from 'react-i18next';
import { useIsCoarsePointer } from './use-projected-payments-viewport';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    '&>*': { marginRight: theme.spacing(4), },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1),
      '&>*': { marginRight: 0, width: '100%', minWidth: 0 },
    },
  },
  textField: {
    height: theme.spacing(4),
    '&>.MuiInputBase-root': {
      height: theme.spacing(4),
      '&>.MuiSelect-select': {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
      },
    },
    '@media (hover: none) and (pointer: coarse)': {
      height: 'auto',
      '&&>.MuiInputBase-root': { height: 'auto', minHeight: 44 },
      '&&>.MuiInputBase-root>.MuiSelect-select': {
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
      },
    },
  },
}));

type PrincipalInterestAmountFieldsProps = {
  methods: UseFormReturn<ProjectedPaymentsForm>;
  disabled?: boolean;
};

const AmountFields = ({
  methods,
  disabled = false
}: PrincipalInterestAmountFieldsProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const data =
    [
      {
        name: 'month',
        text: t('projectedPayments:per-month')
      },
      {
        name: 'week',
        text: t('projectedPayments:per-week')
      },
    ];

  return (
    <span className={classes.root}>
      <Controller
        control={methods.control}
        name="prorations_amount"
        render={({ field }) => (
          <InputCell
            value={field.value}
            prefix="$"
            thousandSeparator
            ariaLabel={t('projectedPayments:amount')}
            onChangeInput={(e: any) => {
              const value = formatCurrencyValueToNumber(e.target.value);
              field.onChange(value);
            }}
          />
        )}
      />

      <Controller
        control={methods.control}
        name="prorations_period"
        render={({ field }) => (
          <TextField
            select
            fullWidth
            disabled={disabled}
            variant="filled"
            value={field.value}
            className={classes.textField}
            InputProps={{ disableUnderline: true }}
            inputProps={{ 'aria-label': `${t('projectedPayments:per-month')} / ${t('projectedPayments:per-week')}` }}
            onChange={(e) => field.onChange(e.target.value)}
          >
            {data.map((element: any) => (
              <MenuItem
                key={element.name}
                value={element.name}
              >
                {element.text}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
    </span>
  );
};

export default AmountFields;
